/*LIBRARY*/
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

/*COMPONENT*/
import ProgressBar from "../common_spinner/ProgressBar";
import SINI_POINT_CONFIG from "./SINI_POINT_CONFIG";
import FLOAT_MENU from "../common_trivial/FLOAT_MENU";

/*REDUX*/
import { set_value_sini } from "../../App/actions/sini_v2";

/*PICTURE*/
import ICON_BACK from "../../Assets/jsx/ICON_BACK";

/*FUNCTION*/
import sort_array from "../../App/validation/sort_array";

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

const SINI_POI_FULL = () => {
  const [mode_tipe, setModeTipe] = useState("tipe_1");
  const [anchor, setAnchor] = useState(null);
  const [modal_layer_config, setModalLayerConfig] = useState(false);

  const dispatch = useDispatch();
  const sini = useSelector((state) => state.sini);
  const loading_reducer = useSelector((state) => state.loading_reducer);
  const insight_reducer = useSelector((state) => state.insight_reducer);

  useEffect(() => {
    on_mount();
  }, []);

  const on_mount = () => {};

  const toggle_layer_config = (e) => {
    setModalLayerConfig(!modal_layer_config);
    if (e) {
      setAnchor(e.currentTarget);
    }
  };

  const on_set_sini_menu_active = () => {
    dispatch(set_value_sini({ key: "sini_menu_active", value: "" }));
    dispatch(
      set_value_sini({ key: "sini_map_show", value: ["poi", "isochrone"] })
    );
  };

  const on_set_mode_tipe = (mode_tipe) => {
    setModeTipe(mode_tipe);
  };

  //local storage
  const language = localStorage?.language || "ina";

  //global props
  const { sini_v2_list, request_id_active, ai_parent_detail_list } = sini;
  const { loading_item_array } = loading_reducer;
  const { list_tipe_1 } = insight_reducer;

  //content
  const merge_array = [...sini_v2_list, ...ai_parent_detail_list];
  const is_loading_poi = loading_item_array.includes("poi");
  const sini_object = merge_array.find(
    (item) => item.request_id === request_id_active
  );
  const poi_features = sini_object?.poi_features || [];
  let poi_resume_1 = sini_object?.poi_resume_1 || [];
  let poi_resume_2 = sini_object?.poi_resume_2 || [];
  let poi_resume_3 = sini_object?.poi_resume_3 || [];

  poi_resume_1 = sort_array(poi_resume_1, "number", false);
  poi_resume_2 = sort_array(poi_resume_2, "number", false);
  poi_resume_3 = sort_array(poi_resume_3, "number", false);

  let content;
  if (is_loading_poi || poi_features.length > 0 || poi_resume_1.length > 0) {
    const max_tipe_1 = poi_resume_1?.[0]?.number;
    content = (
      <section
        className="sini_full_scroll_area"
        style={{ paddingRight: "10px" }}
      >
        {is_loading_poi && (
          <div className="badge background_grey_light margin_bottom margin_right">
            {dict?.["Loading data"]?.[language]}...
          </div>
        )}
        <br />

        <section className="three_container">
          <button
            className={`button_small ${
              mode_tipe === "tipe_1"
                ? "background_black"
                : "background_grey_light"
            }`}
            onClick={() => on_set_mode_tipe("tipe_1")}
            data-mapid="clickTipe1"
          >
            {dict?.["General Category"]?.[language]}
          </button>
          <button
            className={`button_small ${
              mode_tipe === "tipe_2"
                ? "background_black"
                : "background_grey_light"
            }`}
            onClick={() => on_set_mode_tipe("tipe_2")}
            data-mapid="clickTipe2"
          >
            {dict?.["Subcategory"]?.[language]}
          </button>
          <button
            className={`button_small ${
              mode_tipe === "tipe_3"
                ? "background_black"
                : "background_grey_light"
            }`}
            onClick={() => on_set_mode_tipe("tipe_3")}
            data-mapid="clickTipe3"
          >
            {dict?.["Specific Entity"]?.[language]}
          </button>
        </section>

        <br />

        {poi_resume_1.map((element, idx) => {
          const color =
            list_tipe_1?.find(
              (color_element) => color_element?.TIPE_1 === element?.name
            )?.color || "#dedede";

          let formated_number;
          if (element.number) {
            formated_number = parseInt(element.number);
            formated_number = new Intl.NumberFormat("id-ID", {
              style: "decimal",
            }).format(formated_number);
          }
          let child_content;
          if (mode_tipe === "tipe_2") {
            const array_child = poi_resume_2.filter(
              (item) => item.parent === element.name
            );
            const max_tipe_2 = array_child?.[0]?.number;
            child_content = (
              <main className="container margin_top margin_bottom_extra outline_grey">
                {array_child.map((child, idx) => {
                  let formated_number;
                  if (child.number) {
                    formated_number = parseInt(child.number);
                    formated_number = new Intl.NumberFormat("id-ID", {
                      style: "decimal",
                    }).format(formated_number);
                  }
                  return (
                    <section
                      key={idx}
                      style={{
                        paddingBottom: "10px",
                        paddingTop: "10px",
                      }}
                    >
                      <div className="parent_half text_small">
                        <div className="left_half text_left full_width">
                          {child.name}
                        </div>
                        <div className="right_half text_right">
                          {formated_number}
                        </div>
                      </div>
                      <ProgressBar
                        current_number={child.number}
                        total_number={max_tipe_2}
                        color={color}
                        is_hide_text={true}
                      />
                      {child_content}
                    </section>
                  );
                })}
              </main>
            );
          } else if (mode_tipe === "tipe_3") {
            const array_child = poi_resume_3.filter(
              (item) => item.parent_tipe_1 === element.name
            );
            const max_tipe_3 = array_child?.[0]?.number;
            child_content = (
              <main className="container outline_grey margin_top">
                {array_child.map((child, idx) => {
                  let formated_number;
                  if (child.number) {
                    formated_number = parseInt(child.number);
                    formated_number = new Intl.NumberFormat("id-ID", {
                      style: "decimal",
                    }).format(formated_number);
                  }
                  return (
                    <section key={idx} className="margin_bottom_extra">
                      <div className="parent_half text_small">
                        <section className="left_half text_left full_width">
                          <p className="text_medium">{child.name}</p>
                        </section>

                        <section className="right_half text_right">
                          {formated_number}
                        </section>
                      </div>

                      <div className="button_small blue_container margin_bottom">
                        {child?.parent_tipe_2}
                      </div>

                      <ProgressBar
                        current_number={child.number}
                        total_number={max_tipe_3}
                        color={color}
                        is_hide_text={true}
                      />

                      {child_content}
                    </section>
                  );
                })}
              </main>
            );
          }
          return (
            <section key={idx} className="container outline_grey margin_bottom">
              <div className="parent_half text_small">
                <p className="left_half text_left full_width text_bold">
                  {element.name}
                </p>
                <div className="right_half text_right">{formated_number}</div>
              </div>
              <ProgressBar
                current_number={element.number}
                total_number={max_tipe_1}
                color={color}
                is_hide_text={true}
              />
              {child_content}
            </section>
          );
        })}
      </section>
    );
  }

  const modal_layer_config_content = (
    <FLOAT_MENU
      id="basic-menu"
      anchorEl={anchor}
      open={modal_layer_config}
      onClose={toggle_layer_config}
      MenuListProps={{
        "aria-labelledby": "basic-button",
      }}
    >
      <div
        style={{
          width: "250px",
        }}
      >
        <SINI_POINT_CONFIG />
      </div>
    </FLOAT_MENU>
  );

  return (
    <main className="sini_full_parent">
      {modal_layer_config_content}
      <section className="sini_full_header">
        <table>
          <tbody>
            <tr>
              <td
                style={{ width: "30px" }}
                onClick={on_set_sini_menu_active}
                data-mapid="clickBack"
              >
                <ICON_BACK />
              </td>
              <td className="text_left">
                <div className="badge background_grey_light margin_bottom margin_right">
                  Point of Interest
                </div>
                <div
                  className="badge background_grey_light margin_bottom margin_right cursor_pointer"
                  onClick={toggle_layer_config}
                  data-mapid="clickEdit"
                >
                  {dict?.["Edit info on map"]?.[language]}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </section>
      {content}
    </main>
  );
};

export default SINI_POI_FULL;
